import * as React from 'react'

export const SvgVideo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} aria-hidden={true} viewBox="0 0 25 25" {...props}>
    <path
      d="M5.9375 4.02344C6.52344 3.67188 7.26562 3.67188 7.85156 4.0625L19.1016 10.8984C19.6484 11.25 20 11.875 20 12.5C20 13.1641 19.6484 13.7891 19.1016 14.1016L7.85156 20.9766C7.26562 21.3281 6.52344 21.3672 5.9375 21.0156C5.35156 20.7031 5 20.0781 5 19.375V5.625C5 4.96094 5.35156 4.33594 5.9375 4.02344ZM7.1875 5.11719C6.99219 5 6.75781 5 6.5625 5.11719C6.36719 5.19531 6.25 5.42969 6.25 5.625V19.375C6.25 19.6094 6.36719 19.8438 6.5625 19.9219C6.75781 20.0391 6.99219 20.0391 7.1875 19.9219L18.4375 13.0469C18.6328 12.9297 18.75 12.7344 18.75 12.5C18.75 12.3047 18.6328 12.1094 18.4375 11.9922L7.1875 5.11719Z"
      fill={props.fill || '#333'}
    />
  </svg>
)
export default SvgVideo
